<template>
    <div class="change-logo-container">
        <basic-form
            action="/settings/update"
            submit-class="d-none"
            ref="form"
            @submitStatusChange="submitStatus"
            @success="success">

            <input
                type="file"
                ref="logoImageInput"
                name="image"
                v-on:input="change($event)"
                id="logoImageInput"
                accept="image/*"
                class="d-none">

            <basic-button
                :disabled="submitting"
                :loading="submitting"
                type="button"
                cls="text-dark btn-sm btn-outline change_logo p-0"
                icon="fi fi-rr-camera"
                icon-position="left"
                :text="trans('general.defaults.change_logo')"
                @click="select"/>

        </basic-form>
    </div>
</template>

<script>
import BasicButton from "../../../theme/atoms/BasicButton.vue";
import BasicForm from "../../../theme/molecules/BasicForm.vue";

export default {
    name: "ChangeLogo",
    props: {
        logo: {
            type: String,
            default: '/img/logo-placeholder.png'
        }
    },
    data() {
        return {
            url: this.logo,
            submitting: false,
        }
    },
    components: {
        BasicForm, BasicButton
    },
    methods: {
        select() {
            this.$refs.logoImageInput.click();
        },
        change: function (event) {
            const file = event.target.files[0];
            this.url = URL.createObjectURL(file);
            this.$emit('chosen-file', file);
            this.save();
        },
        submitStatus(submitting) {
            this.submitting = submitting;
        },
        save() {
            this.$refs.form.submit();
        },
        success() {
            document.querySelector('.logo-link').innerHTML = `<img class="w-100 contain center space-image logo-image" src="${this.url}" alt="logo">`;
        },
    }
}
</script>
